const normalizeSearchValue = (value) => String(value || '').trim().toLowerCase();

export const getTeamMemberSearchText = (member = {}) => {
  return [
    member.firstName,
    member.lastName,
    `${member.firstName || ''} ${member.lastName || ''}`,
    member.officialEmail,
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();
};

export const filterTeamMembersBySearch = (members = [], query = '') => {
  const normalizedQuery = normalizeSearchValue(query);

  if (!normalizedQuery) {
    return members;
  }

  return members.filter((member) => getTeamMemberSearchText(member).includes(normalizedQuery));
};
